import { Component, ElementRef, ViewChild } from "@angular/core";
import { IAfterGuiAttachedParams, ICellEditorParams } from "ag-grid";
import { ICellEditorAngularComp } from "ag-grid-angular";

export class AgAutoCompleteItem {
	value: any;
	label: string;
	hiddenLabel: string;
	code?: string;
	data?: any;
}


@Component({
  selector: 'ag-auto-complete-editor',
  templateUrl: 'ag-auto-complete.editor.html'
})
export class AgAutoCompleteEditor implements ICellEditorAngularComp {
	isChange: boolean = false;
	params: ICellEditorParams;
	items: AgAutoCompleteItem[];
	suggestions: AgAutoCompleteItem[];
	focusedIndex: number = 0;
	value: any = null;
	newValue: any = null;
	cancel: boolean = false;
	agent: string;
	IE_DATA_LIMIT: number = 200;

	@ViewChild('container')
	container;

	@ViewChild('inputTxt')
	inputTxt: ElementRef;

	@ViewChild("suggestListRef")
  suggestListElRef: ElementRef;

	agInit(params: ICellEditorParams): void {
		this.agent = window.navigator.userAgent.toLowerCase();
		this.params = params;
		this.value = params.value;
		this.items = params['items'];		
		
		if ((this.agent.indexOf('msie') >= 0 || this.agent.indexOf('trident') >= 0) && this.items && this.items.length > this.IE_DATA_LIMIT) {
			this.suggestions = [];
		} else {
			this.suggestions = this.items;
		}
		
		this.focusedIndex = -1;
		// console.log('agInit called', params);
	}


	getValue() {
		// console.log('getValue', this.value);
		return this.newValue;
	}
	
	isPopup?(): boolean {
		// console.log('isPopup called');
		return true;
	}

	isCancelBeforeStart?(): boolean {
		// console.log('isCancelBeforeStart called');
		return false;
	}

	isCancelAfterEnd?(): boolean {
		// console.log('isCancelAfterEnd called');
		return !this.isChange || this.cancel;
	}

	focusIn?(): void {
		// console.log('focusIn called');
	}

	focusOut?(): void {
		// console.log('focusOut called');
	}


	afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
		this.inputTxt.nativeElement.focus();
		if (this.params.charPress) this.inputTxt.nativeElement.value = this.params.charPress;
		// console.log('afterGuiAttached called', this.inputTxt);
	}


	onClick(item: AgAutoCompleteItem) {
		this.selectItem(item);
		this.params.stopEditing();
	}

	onMouseOver(index: number) {
		this.focusedIndex = index;
	}


	selectItem(item: AgAutoCompleteItem) {
		this.newValue = (item ? item.value: null);
		if (this.newValue) this.isChange = true;
	}

	onKeyDown(e) {
		if (e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 27 && e.keyCode !== 38 && e.keyCode !== 40) return;
		if (!this.suggestions) return;
		
    let focusedIndex = this.focusedIndex;
    let suggestListDom = null;
    if(this.suggestListElRef) suggestListDom = this.suggestListElRef.nativeElement;
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

		let item: AgAutoCompleteItem = null;
		if (this.focusedIndex >= 0) item = this.suggestions[this.focusedIndex];
		
		switch (e.keyCode) {
			case 9: //tab
				// this.cancel = true;
				this.selectItem(item);
        break;
			case 13: // enter
				this.selectItem(item);
				this.params.api.clearRangeSelection();
				this.params.api.setFocusedCell(this.params.rowIndex + 1, this.params.column);
			  break;
			case 27: // escape
				this.cancel = true;
				this.params.api.stopEditing();
			  break;
			case 38: // up
				focusedIndex--;
        if (focusedIndex < -1) focusedIndex = -1;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
				if (suggestListItem[focusedIndex]) suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
				e.preventDefault();
				e.stopPropagation();
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > this.suggestions.length - 1) focusedIndex = this.suggestions.length - 1;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
				if (suggestListItem[focusedIndex]) suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
				e.preventDefault();
				e.stopPropagation();
       	break;
			default: return;
    }
    if(e.keyCode != 9) {
      e.preventDefault();
    }
	}


	onKeyUp(e) {
    if (e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 27 || e.keyCode === 38 || e.keyCode === 40) return;
    if (!this.items) return;
		this.isChange = true;

    let value: String = e.target.value;
    const inputValue = value.toUpperCase().replace(/\s/g, '');
    const inputLength = inputValue.length;


		if (inputLength == 0) {
			if ((this.agent.indexOf('msie') >= 0 || this.agent.indexOf('trident') >= 0) && this.items.length > this.IE_DATA_LIMIT) this.suggestions = [];
			else this.suggestions = this.items;
			
			this.focusedIndex = -1;
			return;
		}
		
    let letterCheck: RegExp = /[ㄱ-ㅎ|ㅏ-ㅣ]/;
    if (letterCheck.test(inputValue)) return;
    
    let filteredList: AgAutoCompleteItem[] = [];
    let codeList = [];
		
		if (inputValue.length > 0) {
			filteredList = this.items.filter(
				(item: AgAutoCompleteItem) => {
					if (item && item.label && item.label.toUpperCase().replace(/\s/g, '').indexOf(inputValue) >= 0) return true;
					if (item && item.hiddenLabel && item.hiddenLabel.toUpperCase().replace(/\s/g, '').indexOf(inputValue) >= 0) return true;
					return false;
				}
			);
		}
		
		filteredList.sort((a, b) => {
			if (a.label.length > b.label.length) return 1;
			else if (a.label.length == b.label.length) return 0;
			else return -1;
		});
		
		filteredList.sort((a, b) => {
			let aLabel:String = a.label.toUpperCase().trim().replace(/\s/g, '');
			let bLabel:String = b.label.toUpperCase().trim().replace(/\s/g, '');
			let aIdx = aLabel.indexOf(inputValue);
			let bIdx = bLabel.indexOf(inputValue);

			if (aIdx > bIdx) return 1;
			else if (aIdx == bIdx) return 0;
			else return -1;
		});

		filteredList.sort((a, b) => {
			if (!a.code && !b.code) return 0;

			let aCode:String = a.code.toUpperCase().trim().replace(/\s/g, '');
			let bCode:String = b.code.toUpperCase().trim().replace(/\s/g, '');
			let aIdx = aCode.indexOf(inputValue);
			let bIdx = bCode.indexOf(inputValue);
			
			if (aIdx < 0 && bIdx >=0) return 1;
			else if (aIdx >= 0 && bIdx < 0) return -1;

			if (aIdx > bIdx) return 1;
			else if (aIdx == bIdx) return 0;
			else return -1;
		});

		// let codeMatchIdx:number = filteredList.findIndex(item => {
		// 	if (item.code && item.code == inputValue) return true;
		// 	return false;
		// })
		
		// if (codeMatchIdx >= 0) {
		// 	let codeItem = filteredList[codeMatchIdx];
		// 	filteredList.splice(codeMatchIdx, 1);
		// 	filteredList.splice(0, 0, codeItem);
		// }

		if ((this.agent.indexOf('msie') >= 0 || this.agent.indexOf('trident') >= 0) && filteredList.length > this.IE_DATA_LIMIT) {
			this.suggestions = [];
			this.focusedIndex = -1;
			return;
		}

    this.suggestions = filteredList;
    this.focusedIndex = 0;
  }

}




// WEBPACK FOOTER //
// ./src/app/components/ag-grid/editor/ag-auto-complete.editor.ts